import { lazy } from "react";

import { Navigate } from "react-router-dom";

import { AppPagePaths } from "App/routes/paths";
import { SettingsPaths } from "Pages/settings/paths";

import AgentSettingsRouter from "../AgentSettingsRouter";
import { AgentSettingsPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

const AgentIntegrationsPage = lazy(() => import("./AgentIntgerationsPage/AgentIntegrationsPage"));
const AgentRecordingsGridPage = lazy(() => import("./AgentRecordingsGridPage/AgentRecordingsGridPage"));

export const agentSettingsRoute: RegalRouteObject = {
    path: `${SettingsPaths.mySettings}/*`,
    element: <AgentSettingsRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <Navigate to={`${AppPagePaths.settings}/${AgentSettingsPaths.integrations}`} replace />,
        },
        {
            path: AgentSettingsPaths.integrations,
            element: <AgentIntegrationsPage />,
        },
        {
            path: AgentSettingsPaths.recordings,
            element: <AgentRecordingsGridPage />,
        },
    ],
};
